(function() {
  'use strict';

  /**
   * @ngdoc function
   * @name webAgro1App.controller:WidgetestacaometeorologicaCtrl
   * @description
   * # WidgetestacaometeorologicaCtrl
   * Controller of the webAgro1App
   */
  angular
    .module('webAgro1App')
    .controller('WidgetEstacaoMeteorologicaCtrl', WidgetEstacaoMeteorologica);

  WidgetEstacaoMeteorologica.$inject = [
    '$rootScope',
    '$scope',
    '$http',
    'LoadingService',
    'Dashboard'
  ];

  function WidgetEstacaoMeteorologica($rootScope, $scope, $http, LoadingService, Dashboard) {
    var vm = this;

    //////////////////////////////////////////
    // Controller data
    vm.loading = false;
    vm.empty = false;
    vm.error = false;
    vm.data = {};
    vm.widgetClasses = {
      'two-rows': false,
      'single-row': false
    };

    //////////////////////////////////////////
    // Bindable methods

    //////////////////////////////////////////
    // Function declarations

    function reloadData() {
      vm.loading = true;
      vm.empty = false;
      vm.error = false;
      Dashboard.dadosMeteorologicos({
        data_inicial: moment().format('YYYY-MM-DD'),
        data_final: moment().format('YYYY-MM-DD'),
        propriedade: ($scope.widget.dataModelOptions.propriedade || $rootScope.currentPropriedade).id,
        type: 'estacao'
      }).then(function(response) {
        var data = response.data;

        if (data.length < 1) {
          vm.empty = true;
          return;
        }

        var last = data.slice(-1)[0];
        vm.data.lastDate = moment(last.data + ' ' + last.hora).format('DD/MM HH:mm');
        vm.data.temperature = Math.round(last.temperatura);
        vm.data.pressure = Math.round(last.pressao);
        vm.data.humidity = Math.round(last.umidade);
        vm.data.wind = Math.round(last.vento);

        vm.data.rain = data.reduce(function(last, current) {
          return last + current.chuva;
        }, 0);

        vm.empty = false;
      }).catch(function(error) {
        console.error(error);
        vm.error = true;
      }).finally(function() {
        vm.loading = false;
      });
    }

    //////////////////////////////////////////
    // Controller logic
    $rootScope.initialize.then(function() {
      $scope.widget.data = {};

      $scope.widget.data.propriedades = $rootScope.propriedades.map(function(propriedade) {
        return {
          id: propriedade.id,
          descricao: propriedade.descricao
        };
      });

      reloadData();

      $scope.$watch('widget.size.width', function() {
        // Explaining this calculation:
        // Widget width is in %, so to calculate its true px width, we divide by 100, to get decimal and multiply it by screen width
        // This will get us the size relative to the screen. Minus 40 because that's the container's padding. Example:
        // Width: 50%, screen 1920px
        // 50 / 100 = 0.5 * 1920 = 960 (half screen) - 40 = 920 (half container)
        var trueWidth = Number($scope.widget.size.width.slice(0, -1)) / 100 * window.innerWidth - 40;

        if (trueWidth >= 420 && trueWidth < 1000) {
          vm.widgetClasses['two-rows'] = true;
          vm.widgetClasses['single-row'] = false;
        } else if (trueWidth >= 1000) {
          vm.widgetClasses['two-rows'] = false;
          vm.widgetClasses['single-row'] = true;
        } else {
          vm.widgetClasses['two-rows'] = false;
          vm.widgetClasses['single-row'] = false;
        }
      });

      $scope.$watch('widget.dataModelOptions.propriedade.id', reloadData);
    });
  }

}());
